import { actionInvoke, ActionStatus, useClientRPC } from 'lib/rpcts'
import {
    A2UIServiceCreateSurfaceFeedbackRequest,
    A2UIServiceCreateSurfaceFeedbackResponse,
    A2UIServiceListSurfacesRequest,
    A2UIServiceListSurfacesResponse,
    A2UIServiceSubmitActionRequest,
    A2UIServiceSubmitActionResponse,
} from 'pbts/c1/api/a2ui/v1/a2ui'
import { A2UIServiceClient } from 'pbts/c1/api/a2ui/v1/a2ui.client'
import { createMutationApi } from 'redux_toolkit/lib/createMutationApi'

/**
 * Hook to get the A2UI service client.
 */
export const useA2UIClient = (): A2UIServiceClient | undefined => {
    return useClientRPC(A2UIServiceClient)
}

/**
 * Submit an A2UI action to the backend.
 */
export const submitA2UIAction = async (
    client: A2UIServiceClient,
    req: A2UIServiceSubmitActionRequest,
): Promise<ActionStatus<A2UIServiceSubmitActionResponse>> => {
    return actionInvoke(req, client.submitAction.bind(client))
}

/**
 * List active A2UI surfaces for a conversation.
 */
export const listA2UISurfaces = async (
    client: A2UIServiceClient,
    req: A2UIServiceListSurfacesRequest,
): Promise<ActionStatus<A2UIServiceListSurfacesResponse>> => {
    return actionInvoke(req, client.listSurfaces.bind(client))
}

/**
 * Create surface feedback with a snapshot.
 */
export const createSurfaceFeedback = async (
    client: A2UIServiceClient,
    req: A2UIServiceCreateSurfaceFeedbackRequest,
): Promise<ActionStatus<A2UIServiceCreateSurfaceFeedbackResponse>> => {
    return actionInvoke(req, client.createSurfaceFeedback.bind(client))
}

/**
 * Hook for creating surface feedback.
 */
export const createSurfaceFeedbackApi = createMutationApi(
    A2UIServiceClient,
    'createSurfaceFeedback',
)
